module.exports = __webpack_public_path__ + "img/right3-mobile.0a7b7c44.png";